import type { Soundscape, SoundscapeGroup } from '@/entities/soundscape'

// Раздел, который показывает плеер: выбранный руками, иначе тот, откуда идёт
// звук, иначе первый. Выбор общий для шапки и страницы фокуса, поэтому решает
// не компонент, а эта функция — оба места отвечают на вопрос одинаково.
export function currentGroup(
  groups: SoundscapeGroup[],
  picked: string | null,
  activeSlug: string | null,
): SoundscapeGroup | undefined {
  const byPick = picked === null ? undefined : groups.find((g) => g.key === picked)
  if (byPick) return byPick
  const byPlaying = groups.find((g) => g.items.some((s) => s.slug === activeSlug))
  return byPlaying ?? groups[0]
}

// Соседний режим раздела по кругу: delta +1 — дальше, -1 — назад. Звучащего в
// разделе нет (или молчим) — «дальше» начинает раздел с начала, «назад» с конца.
export function stepInGroup(
  items: Soundscape[],
  activeSlug: string | null,
  delta: 1 | -1,
): Soundscape | undefined {
  if (items.length === 0) return undefined
  const idx = items.findIndex((s) => s.slug === activeSlug)
  if (idx < 0) return delta > 0 ? items[0] : items[items.length - 1]
  return items[(idx + delta + items.length) % items.length]
}

// Что запустит «старт» в разделе: продолжаем с последнего слушанного, если он
// из этого раздела, иначе с начала — переключение раздела не должно молча
// возвращать режим из соседнего.
export function startInGroup(items: Soundscape[], lastSlug: string | null): Soundscape | undefined {
  return items.find((s) => s.slug === lastSlug) ?? items[0]
}

// Режим для кнопки «включить музыку для концентрации»: последний слушанный,
// иначе первый из модальности focus, иначе просто первый в каталоге.
export function focusStart(list: Soundscape[], lastSlug: string | null): Soundscape | undefined {
  return (
    list.find((s) => s.slug === lastSlug) ?? list.find((s) => s.modality === 'focus') ?? list[0]
  )
}
